export const forBusiness_beauty_essential = [
	{
		icon: '💑',
		title: 'essentialData_title1',
		subtitle: 'essentialData_subtitle1',
	},
	{
		icon: '🚀',
		title: 'essentialData_title2',
		subtitle: 'essentialData_subtitle2',
	},
	{
		icon: '🖼',
		title: 'essentialData_title3',
		subtitle: 'essentialData_subtitle3',
	},
	{
		icon: '🤘',
		title: 'essentialData_title4',
		subtitle: 'essentialData_subtitle4',
	},
];
